module.exports = __webpack_public_path__ + "media/xinzhizao.238f57b8.mp4";